import { render, staticRenderFns } from "./PrintStudiengaengeOfBewerbung.vue?vue&type=template&id=f384c1f6"
import script from "./PrintStudiengaengeOfBewerbung.vue?vue&type=script&lang=js"
export * from "./PrintStudiengaengeOfBewerbung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports